<template>
  <div class="tenant-client-list">
    <!-- 统计卡片 -->
    <div class="stats-row">
      <div class="stat-card">
        <div class="stat-label">客户端总数</div>
        <div class="stat-value">{{ stats.clientTotal || 0 }}</div>
      </div>
      <div class="stat-card">
        <div class="stat-label">启用中</div>
        <div class="stat-value stat-value-green">{{ stats.enabledTotal || 0 }}</div>
      </div>
      <div class="stat-card">
        <div class="stat-label">服务设备总数（台）</div>
        <div class="stat-value">{{ formatNumber(stats.serviceDeviceTotal) || 0 }}</div>
      </div>
    </div>

    <!-- 表格 -->
    <div class="table-wrap">
      <div class="table-header">
        <div class="table-title">该租户名下客户端</div>
        <a-button type="primary" icon="plus" @click="handleAdd">添加客户端</a-button>
      </div>

      <a-table :columns="columns" :data-source="dataSource" :rowKey="(record) => record.id" :pagination="pagination"
        @change="handleTableChange" :loading="loading" :scroll="{ x: 1000 }" size="middle">
        <span slot="index" slot-scope="text, record, idx">{{ (pagination.current - 1) * pagination.pageSize + idx + 1
          }}</span>
        <span slot="clientId" slot-scope="text" class="mono-text">{{ text || '--' }}</span>
        <span slot="clientName" slot-scope="text">{{ text || '--' }}</span>
        <span slot="clientCategoryDesc" slot-scope="text">
          <a-tag v-if="text" color="orange">{{ getCategoryLabel(text) }}</a-tag>
          <span v-else>--</span>
        </span>
        <span slot="clientTypeDesc" slot-scope="text">
          <a-tag v-if="text" :color="getTypeColor(text)">{{ getTypeLabel(text) }}</a-tag>
          <span v-else>--</span>
        </span>
        <span slot="serviceDeviceCount" slot-scope="text">{{ formatNumber(text) || 0 }}</span>
        <span slot="accessTypeCount" slot-scope="text">{{ text || 0 }}</span>
        <span slot="status" slot-scope="text">
          <span v-if="text == 'ENABLED'" class="status-enable">● 启用</span>
          <span v-else class="status-disable">● 停用</span>
        </span>
        <span slot="action" slot-scope="text, record">
          <a @click="toDetail(record)">查看详情</a>
          <a-divider type="vertical" />
          <a class="delete-link" @click="handleRemove(record)">删除</a>
        </span>
      </a-table>
    </div>

    <!-- 添加弹窗 -->
    <add-tenant-client :visible="addVisible" :tenant-id="tenantId" :tenant-name="tenantName" @close="addVisible = false"
      @refresh="init" />

    <!-- 删除确认弹窗 -->
    <remove-tenant-client :visible="removeVisible" :record="currentRemoveRecord" @close="removeVisible = false"
      @confirm="handleRemoveConfirm" />
  </div>
</template>

<script>
import AddTenantClient from './modal/AddTenantClient.vue'
import RemoveTenantClient from './modal/RemoveTenantClient.vue'
import { CLIENT_TYPES, CLIENT_CATEGORIES } from '../../clientManagement/clientConstants.js'

const columns = [
  { title: '序号', key: 'index', scopedSlots: { customRender: 'index' }, width: 60, align: 'center' },
  { title: 'ClientId', dataIndex: 'clientId', key: 'clientId', scopedSlots: { customRender: 'clientId' }, width: 180 },
  { title: '客户端名称', dataIndex: 'clientName', key: 'clientName', scopedSlots: { customRender: 'clientName' }, width: 160 },
  { title: '分类', dataIndex: 'clientCategoryDesc', key: 'clientCategoryDesc', scopedSlots: { customRender: 'clientCategoryDesc' }, width: 110, },
  { title: '类型', dataIndex: 'clientTypeDesc', key: 'clientTypeDesc', scopedSlots: { customRender: 'clientTypeDesc' }, width: 130, },
  { title: '服务设备数', dataIndex: 'serviceDeviceCount', key: 'serviceDeviceCount', scopedSlots: { customRender: 'serviceDeviceCount' }, width: 120, },
  { title: '接入型号数', dataIndex: 'accessTypeCount', key: 'accessTypeCount', scopedSlots: { customRender: 'accessTypeCount' }, width: 120, },
  { title: '状态', dataIndex: 'status', key: 'status', scopedSlots: { customRender: 'status' }, width: 90, align: 'center' },
  { title: '操作', key: 'action', scopedSlots: { customRender: 'action' }, width: 140, fixed: 'right', align: 'center' },
]

export default {
  name: 'TenantClientList',
  components: { AddTenantClient, RemoveTenantClient },
  props: {
    tenantId: { type: String, default: '' },
    tenantName: { type: String, default: '' },
  },
  data() {
    return {
      columns,
      dataSource: [],
      loading: false,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: (total) => `共 ${total} 条`,
        pageSizeOptions: ['10', '20', '50'],
      },
      stats: { clientTotal: 0, enabledTotal: 0, serviceDeviceTotal: 0 },
      addVisible: false,
      removeVisible: false,
      currentRemoveRecord: null,
    }
  },
  created() {
    if (this.tenantId) {
      this.init()
    }
  },
  watch: {
    tenantId() {
      if (this.tenantId) {
        this.init()
      }
    },
  },
  methods: {
    init() {
      this.fetchList()
      this.computeStats()
    },
    fetchList() {
      if (!this.tenantId) return

      this.loading = true
      const params = {
        tenantId: this.tenantId,
        clientCategory: null,
        clientType: null,
        keyword: null,
        page: this.pagination.current,
        pageSize: this.pagination.pageSize,
        status: null,
        tenantName: this.tenantName,
      }

      this.$api.getTenantClients(params).then((res) => {
        if (res && res.code == 0) {
          const list = res.data.records || []
          this.dataSource = list
          this.pagination.total = Number(res.data.total || 0)
        }
      }).catch((err) => {
        console.error(err)
      }).finally(() => {
        this.loading = false
      })
    },

    computeStats() {
      this.$api.getTenantClientStats(this.tenantId).then((res) => {
        if (res && res.code == 0) {
          this.stats = res.data
        }
      }).catch((err) => {
        console.error(err)
      })
    },

    handleTableChange({ current, pageSize }) {
      this.pagination.current = current
      this.pagination.pageSize = pageSize
      this.fetchList()
    },

    handleAdd() {
      this.addVisible = true
    },

    handleRemove(record) {
      this.currentRemoveRecord = record
      this.removeVisible = true
    },

    handleRemoveConfirm(done) {
      this.$api.removeClientFromTenant(this.tenantId, this.currentRemoveRecord.id).then((res) => {
        done && done()
        if (res && res.code == 0) {
          this.$message.success('已移除')
          this.removeVisible = false
          this.init()
        } else {
          this.$message.error(res && res.message ? res.message : '操作失败')
        }
      }).catch(() => {
        this.removeVisible = false
        this.init()
      }).finally(() => {
        this.removeVisible = false
      })
    },

    toDetail(record) {
      this.$router.push({
        name: 'ClientDetail',
        query: { id: record.id },
      })
    },

    /* 工具 */
    getTypeLabel(value) {
      const t = CLIENT_TYPES.find((i) => i.value === value)
      return t ? t.label : value
    },
    getTypeColor(value) {
      const t = CLIENT_TYPES.find((i) => i.value === value)
      return t ? t.color : 'blue'
    },
    getCategoryLabel(value) {
      const t = CLIENT_CATEGORIES.find((i) => i.value === value)
      return t ? t.label : value
    },
    formatNumber(val) {
      if (!val) return 0
      return Number(val).toLocaleString()
    },
  },
}
</script>

<style lang="less" scoped>
.tenant-client-list {
  padding: 16px;
}

.stats-row {
  display: flex;
  gap: 16px;
  margin-bottom: 16px;

  .stat-card {
    flex: 1;
    border: 1px solid #f0f0f0;
    border-radius: 6px;
    padding: 16px 20px;
    background: #f5f6f8;

    .stat-label {
      font-size: 13px;
      color: #666;
      margin-bottom: 8px;
    }

    .stat-value {
      font-size: 28px;
      font-weight: 600;
      color: #151515;
      line-height: 1.2;
    }

    .stat-value-green {
      color: #52c41a;
    }
  }
}

.table-wrap {
  border: 1px solid #f0f0f0;
  border-radius: 6px;
  padding: 16px;
  background: #fff;
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;

  .table-title {
    font-size: 15px;
    font-weight: 600;
    color: #151515;
    padding-left: 10px;
    border-left: 3px solid #1890ff;
  }
}

.mono-text {
  font-family: Menlo, Monaco, Consolas, monospace;
}

.status-enable {
  color: #52c41a;
}

.status-disable {
  color: #bfbfbf;
}

.delete-link {
  color: #ff4d4f;
}

.delete-link:hover {
  color: #ff7875;
}
</style>
